/*
import {
  _ht,
  _hm,
  _hmDTM,
  useGblz,
  l,
  f,
  gs,
} from 'lib';
*/
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as gs from "./_csGbl";
import * as _ht from './_ht';
import * as _hm from './_hf';
import * as _hmDTM from './_hfDTM';

import * as ihd from './ihd';

//export { L } from './IcvI17a';
//export { saveAsync, D } from './IcvI17b';

export const ilzI18z = () => ({
  i18rz: {},
  i15rz: {},
}) as _ht.dz;

export const crtI18z = async () => {
  const _gUserz = gs.useUserz();
  const _i18z = ilzI18z();
  _hm.udtDz(_i18z.i18rz, {
    ...ihd.i('i18r'),
    i18r_31r1f: _gUserz.crt._31rz?._fst,
    i18rd1100s: _hmDTM.getTdy(),
  });
  return _i18z;
};

export const loadI18rLsAsync = async (pz?: {
  _31r_fst?: _ht.n,
  word?: _ht.s,
  id?: _ht.s,
  cdn?: _ht.s,
  lwrType?: 1,
}) => {
  _hm.logOst('icvI18___Mz.loadI18rLsAsync -> ihdI18.grtPzForLoadI18rPs');
  let _cdn = cmFTH.vdd();
  if (pz?._31r_fst && pz?._31r_fst > 0) _cdn += ` AND i18r_31r1f = ${pz?._31r_fst}`;
  if (pz?.word) _cdn += ` AND (i18rab100s LIKE '%${pz?.word}%' OR i18ra1100s LIKE '%${pz?.word}%' OR _pfx LIKE '%${pz?.word}%')`
  //  if (pz?.id) _cdn += ` AND (i18ra4120s = '${pz?.id}%' OR i18ra4220s = '${pz?.id}%' OR i18ra4320s = '${pz?.id}%')`
  if (pz?.id) _cdn += ` AND (i18ra4120s = '${pz?.id}' OR i18ra4220s = '${pz?.id}' OR i18ra4320s = '${pz?.id}')`
  if (pz?.cdn) _cdn += ` AND (${pz?.cdn})`;
  //hf.l(`icvI18___Mz 45: ${_cdn}`);
  const _ls = cmFTH.loadLsAsync({
    tgt: 'i18rs',
    cdn: _cdn,
    fld: `_fst as key, i18rab100s || ' ' || _pfx as pfx, i18rab100s || _pfx || i18ra1100s as sch, *`,
    tailz: {
      odr: 'i18rab100s',
    },
    lwrz:
      pz?.lwrType == 1 ? // 団体一覧
        {
          i16rs: {
            tgt: 'i16rs',
            cdn: cmFTH.vdd() + ` AND _fst = {i18ri16r1f}`,
            rlcz: {
              i18ri16r1f: 'i18rs.i18ri16r1f'
            }
          }
        }
        : undefined,
  });
  return _ls;
};

export const loadI18rDzAsync = async (pz: {
  i18r_fst?: _ht.n,
  id?: _ht.s,
  i18rab100s?: _ht.s,
  vsn?: _ht.n,
  bDmn?: _ht.b,
}) => {
  _hm.logOst('icvI18___Mz.loadI18rDzAsync -> ihdI18.grtPzForLoadI18rPs');
  //  const _gUserz = gs.useUserz();
  //  let _cdn = cmFTH.vdd() + ` AND i18r_31r1f=${_gUserz.crt._31rz._fst}`;
  //  let _cdn = cmFTH.vdd();
  let _cdn =
    (pz?.vsn && pz?.vsn > 0) ?
      (pz?.bDmn == false) ?
        (cmFTH.vdd(false, false) + ` AND _vsn = ${pz?.vsn}`)
        : (cmFTH.vdd(false) + ` AND _vsn = ${pz?.vsn}`)
      :
      (pz?.bDmn == false) ?
        cmFTH.vdd(true, false)
        : cmFTH.vdd();
  if (pz?.i18r_fst) _cdn += ` AND _fst = ${pz.i18r_fst ?? -1}`;
  if (pz?.id) _cdn += ` AND (i18ra4120s = '${pz?.id}' OR i18ra4220s = '${pz?.id}' OR i18ra4320s = '${pz?.id}')`
  if (pz?.i18rab100s) _cdn += ` AND i18rab100s = '${pz?.i18rab100s ?? ''}'`;
  if (!pz?.i18r_fst && !pz?.id && !pz?.i18rab100s) _cdn += ` AND false`; // i18r_fst, id のどちらかが必須
  //hf.l(`icvI18___Mz 83: ${_cdn}`)
  const _dz = await cmFTH.loadDzAsync({
    tgt: 'i18rs',
    cdn: _cdn,
    lwrz: {
      i15rs: {
        tgt: 'i15rs',
        cdn: cmFTH.vdd(true, false) + ` AND _dmn = {i18r_dmn} AND _fst = {i18ri15r1f}`,
        rlcz: {
          i18r_dmn: 'i18rs._dmn',
          i18ri15r1f: 'i18rs.i18ri15r1f'
        }
      },
    }
  });
  //hf.l(`icvI18___Mz 106: ${hf.s(_dz)}`)
  return {
    i18rz: { ..._dz, cldz: undefined },
    i15rz: _hm.get1(_dz.cldz?.i15rs, {}),
  };
};

export const saveI18rDzAsync = async (pz: {
  i18z: _ht.dz,
  sPz?: _ht.dz,
}) => {
  const _gUserz = gs.useUserz();
  const _i19ra1220i = _gUserz.crt.i19rz.i19ra1220i;
  const _dz = await cmFTH.ugdDzAsync({
    tgt: 'i18rs',
    dz: {
      ...pz.i18z.i18rz,
      i18ra4110s: _hm.cvtEml(pz.i18z.i18rz.i18ra4110s ?? ''),
      i18ra4210s: _hm.cvtEml(pz.i18z.i18rz.i18ra4210s ?? ''),
      i18ra4310s: _hm.cvtEml(pz.i18z.i18rz.i18ra4310s ?? ''),
    },
    atrs:
      pz.i18z.i18rz._dlt != 1 ?
        [].concat(
          ihd.f('_icn', 'i18r').atrs, // 団体ID
          ihd.f('i18rab100s').atrs, // 団体番号
          ihd.f('i18ra4110s').atrs, // メールアドレス（主）、全てで実行
          ihd.f('i18ra4210s').atrs, // メールアドレス（副1）、全てで実行
          ihd.f('i18ra4310s').atrs, // メールアドレス（副1）、全てで実行
          _hm.i(_i19ra1220i, [20]) ? ihd.f('i18ra4120s').atrs20 : undefined, // ログインID（主）
          _hm.i(_i19ra1220i, [30]) ? ihd.f('i18ra4120s').atrs30 : undefined, // ログインID（主）
          _hm.i(_i19ra1220i, [20]) ? ihd.f('i18ra4220s').atrs : undefined, // ログインID（副1）
          _hm.i(_i19ra1220i, [20]) ? ihd.f('i18ra4320s').atrs : undefined, // ログインID（副2）
          _hm.i(_i19ra1220i, [20, 30]) ? ihd.f('i18ra4130s').atrs : undefined, // パスワード（主）
          _hm.i(_i19ra1220i, [20]) ? ihd.f('i18ra4230s').atrs : undefined, // パスワード（副1）
          _hm.i(_i19ra1220i, [20]) ? ihd.f('i18ra4330s').atrs : undefined, // パスワード（副1）
        )
        : undefined,
  });
  if (pz.sPz) pz.sPz.set({
    _fst: _dz._fst,
    _key: _dz._key,
  })
  return {
    i18rz: { ..._dz, cldz: undefined },
  };
};

export const chkI18zAsync = async (pz: {
  role: 's' | 'd', // s: staff, d: dantai 
  i18z: _ht.dz,
  sMsgz: _ht.dz,
  chkStep?: _ht.n,
}) => {
  const _gUserz = gs.useUserz();
  const _i19ra1220i = _gUserz.crt.i19rz?.i19ra1220i;
  const _i18rz = pz.i18z.i18rz;
  const _b = await _hm.ectSrlAsync([
    async () => { // メールアドレスの入力確認
      let _b = true;
      if (_hm.i(pz.role, ['d']) && _hm.i(_i19ra1220i, [10])) { // 団体のみ
        if (
           !_hm.f(_i18rz.i18ra4110s) &&
          !_hm.f(_i18rz.i18ra4210s) &&
          !_hm.f(_i18rz.i18ra4310s)
        ) {
          _b = false;
          pz.sMsgz.show({
            textCz: {
              textz: {
                pfx: `メールアドレスが１つ以上入力されていないため、指定された操作を行うことができません`
              }
            }
          })
        }
      }
      return _b;
    },
    async () => { // メールアドレスの重複確認
      let _b = true;
      if (_hm.i(pz.role, ['d', 's'])) {
        if (
          (_hm.f(_i18rz.i18ra4110s) && _i18rz.i18ra4110s == _i18rz.i18ra4210s) ||
          (_hm.f(_i18rz.i18ra4210s) && _i18rz.i18ra4110s == _i18rz.i18ra4310s) ||
          (_hm.f(_i18rz.i18ra4310s) && _i18rz.i18ra4210s == _i18rz.i18ra4310s)
        ) {
          _b = false;
          pz.sMsgz.show({
            textCz: {
              textz: {
                pfx: `同じメールアドレスが複数入力されているため、指定された操作を行うことができません`
              }
            }
          })
        }
      }
      return _b;
    },
    async () => { // ログインID の入力
      let _b = true;
      if (_hm.i(pz.role, ['d']) && _hm.i(_i19ra1220i, [20]) && pz.chkStep != 0) { // 団体のみ
        if (
          !_hm.f(_i18rz.i18ra4120s) &&
          !_hm.f(_i18rz.i18ra4220s) &&
          !_hm.f(_i18rz.i18ra4320s)
        ) {
          _b = false;
          pz.sMsgz.show({
            textCz: {
              textz: {
                pfx: `ログインIDが入力されていないため、指定された操作を行うことができません`
              }
            }
          })
        }
      }
      return _b;
    },
    async () => {
      let _b = true;
      if (_hm.i(pz.role, ['d', 's']) && _hm.i(_i19ra1220i, [20])) {
        if (
          (_hm.f(_i18rz.i18ra4120s) && !_hm.chkHkk(_i18rz.i18ra4120s, false)) ||
          (_hm.f(_i18rz.i18ra4220s) && !_hm.chkHkk(_i18rz.i18ra4220s, false)) ||
          (_hm.f(_i18rz.i18ra4320s) && !_hm.chkHkk(_i18rz.i18ra4320s, false))
        ) {
          _b = false;
          pz.sMsgz.show({
            textCz: {
              textz: {
                //                pfx: `ログインIDに半角英数字以外が入力されているため、指定された操作を行うことができません`
                pfx: `ログインIDに半角以外が入力されているため、指定された操作を行うことができません`
              }
            }
          })
        }
      }
      return _b;
    },
    async () => {
      let _b = true;
      if (_hm.i(pz.role, ['d', 's']) && _hm.i(_i19ra1220i, [20])) {
        if (
          (_hm.f(_i18rz.i18ra4120s) && !(_i18rz.i18ra4120s.length >= 5)) || // 20231113 変更
          (_hm.f(_i18rz.i18ra4220s) && !(_i18rz.i18ra4220s.length >= 5)) || // 20231113 変更
          (_hm.f(_i18rz.i18ra4320s) && !(_i18rz.i18ra4320s.length >= 5)) // 20231113 変更
        ) {
          _b = false;
          pz.sMsgz.show({
            textCz: {
              textz: {
                pfx: `ログインIDが5桁以上でないため、指定された操作を行うことができません`
              }
            }
          })
        }
      }
      return _b;
    },
    async () => { // 同一団体におけるログインIDの重複
      let _b = true;
      if (_hm.i(pz.role, ['d', 's']) && _hm.i(_i19ra1220i, [20])) {
        if (
          (_hm.f(_i18rz.i18ra4120s) && _i18rz.i18ra4120s == _i18rz.i18ra4220s) ||
          (_hm.f(_i18rz.i18ra4120s) && _i18rz.i18ra4120s == _i18rz.i18ra4320s) ||
          (_hm.f(_i18rz.i18ra4220s) && _i18rz.i18ra4220s == _i18rz.i18ra4320s)
        ) {
          _b = false;
          pz.sMsgz.show({
            textCz: {
              textz: {
                pfx: `同じログインIDが複数入力されているため、指定された操作を行うことができません`
              }
            }
          })
        }
      }
      return _b;
    },
    async () => { // 他団体とのログインID の重複確認
      let _b = true;
      if (_hm.i(pz.role, ['d', 's']) && _hm.i(_i19ra1220i, [20])) {
        const _ls1 =
          _hm.f(_i18rz.i18ra4120s) ?
            await loadI18rLsAsync({
              id: _i18rz.i18ra4120s,
              cdn: `_fst <> ${_i18rz._fst ?? -1}`,
            })
            : [];
        const _ls2 =
          _hm.f(_i18rz.i18ra4220s) ?
            await loadI18rLsAsync({
              id: _i18rz.i18ra4220s,
              cdn: `_fst <> ${_i18rz._fst ?? -1}`,
            })
            : [];
        const _ls3 =
          _hm.f(_i18rz.i18ra4320s) ?
            await loadI18rLsAsync({
              id: _i18rz.i18ra4320s,
              cdn: `_fst <> ${_i18rz._fst ?? -1}`,
            })
            : [];
        //hf.l(`icvI18___Mz 279: ${hf.s(_ls1)}`);
        //hf.l(`icvI18___Mz 280: ${hf.s(_ls2)}`);
        //hf.l(`icvI18___Mz 281: ${hf.s(_ls3)}`);
        if (_ls1.length > 0 || _ls2.length > 0 || _ls3.length > 0) {
          _b = false;
          pz.sMsgz.show({
            textCz: {
              textz: {
                pfx: '他の団体とログインIDが重複しているため、指定された操作を行うことができません',
              }
            }
          })
        }
      }
      return _b;
    },
    async () => {
      let _b = true;
      if (_hm.i(pz.role, ['d', 's']) && _hm.i(_i19ra1220i, [20])) {
        if (
          (_hm.f(_i18rz.i18ra4120s) && !_hm.f(_i18rz.i18ra4130s)) ||
          (_hm.f(_i18rz.i18ra4220s) && !_hm.f(_i18rz.i18ra4230s)) ||
          (_hm.f(_i18rz.i18ra4320s) && !_hm.f(_i18rz.i18ra4330s))
        ) {
          _b = false;
          pz.sMsgz.show({
            textCz: {
              textz: {
                pfx: `パスワードが入力されていないため、指定された操作を行うことができません`
              }
            }
          })
        }
      }
      return _b;
    },
    async () => {
      let _b = true;
      if (_hm.i(pz.role, ['d', 's']) && _hm.i(_i19ra1220i, [30])) {
        if (
          !_hm.f(_i18rz.i18ra4130s) &&
          !_hm.f(_i18rz.i18ra4230s) &&
          !_hm.f(_i18rz.i18ra4330s)
        ) {
          _b = false;
          pz.sMsgz.show({
            textCz: {
              textz: {
                pfx: `パスワードが入力されていないため、指定された操作を行うことができません`
              }
            }
          })
        }
      }
      return _b;
    },
    async () => {
      let _b = true;
      if (_hm.i(pz.role, ['d', 's']) && _hm.i(_i19ra1220i, [20, 30])) {
        if (
          (_hm.f(_i18rz.i18ra4130s) && !_hm.chkHkk(_i18rz.i18ra4130s, false)) ||
          (_hm.f(_i18rz.i18ra4230s) && !_hm.chkHkk(_i18rz.i18ra4230s, false)) ||
          (_hm.f(_i18rz.i18ra4330s) && !_hm.chkHkk(_i18rz.i18ra4330s, false))
        ) {
          _b = false;
          pz.sMsgz.show({
            textCz: {
              textz: {
                //                pfx: `パスワードに半角英数字以外が入力されているため、指定された操作を行うことができません`
                pfx: `パスワードに半角以外が入力されているため、指定された操作を行うことができません`
              }
            }
          })
        }
      }
      return _b;
    },
    async () => {
      let _b = true;
      if (_hm.i(pz.role, ['d', 's']) && _hm.i(_i19ra1220i, [20, 30])) {
        if (
          (_hm.f(_i18rz.i18ra4130s) && !(_i18rz.i18ra4130s.length >= 6)) ||
          (_hm.f(_i18rz.i18ra4230s) && !(_i18rz.i18ra4230s.length >= 6)) ||
          (_hm.f(_i18rz.i18ra4330s) && !(_i18rz.i18ra4330s.length >= 6))
        ) {
          _b = false;
          pz.sMsgz.show({
            textCz: {
              textz: {
                pfx: `パスワードが6桁以上でないため、指定された操作を行うことができません`
              }
            }
          })
        }
      }
      return _b;
    },
    async () => { // 必須項目のチェック
      let _b = true;
      if (_hm.i(pz.role, ['s'])) {
        if (
          !(_i18rz.i18ri15r1f >= 0) // 団体種別
        ) {
          //hf.l('icvI18___Mz 382: here');
          _b = false;
        }
        if (
          !(_hm.f(_i18rz._pfx)) // 団体名
        ) {
          //hf.l('icvI18___Mz 388: here');
          _b = false;
        }
        if (
          _i18rz.i18raa100i > 0 && !(_i18rz.i18raa300i > 0) // 減免理由
        ) {
          //hf.l('icvI18___Mz 394: here');
          _b = false;
        }
        if (
          _i18rz.i18raa100i > 0 && !(_i18rz.i18raa200i > 0) // 減免率
        ) {
          //hf.l('icvI18___Mz 400: here');
          _b = false;
        }
        if (
          _hm.j(_gUserz.crt.i19rz.i19ra3200j) && _hm.j(_gUserz.crt.i19rz.i19ra3200j)["110"] == 1 &&
          !_hm.f(_i18rz.i18ra3100s) // 郵便番号
        ) {
          //hf.l('icvI18___Mz 407: here');
          _b = false;
        }
        if (
          _hm.j(_gUserz.crt.i19rz.i19ra3200j) && _hm.j(_gUserz.crt.i19rz.i19ra3200j)["120"] == 1 &&
          !_hm.f(_i18rz.i18ra3200s) // 都道府県
        ) {
          //hf.l('icvI18___Mz 414: here');
          _b = false;
        }
        if (
          _hm.j(_gUserz.crt.i19rz.i19ra3200j) && _hm.j(_gUserz.crt.i19rz.i19ra3200j)["130"] == 1 &&
          !_hm.f(_i18rz.i18ra3300s) // 市区町番地
        ) {
          //hf.l('icvI18___Mz 421: here');
          _b = false;
        }
        if (
          _hm.j(_gUserz.crt.i19rz.i19ra3200j) && _hm.j(_gUserz.crt.i19rz.i19ra3200j)["210"] == 1 &&
          !_hm.f(_i18rz.i18ra3510s) // 電話番号（主）
        ) {
          //hf.l('icvI18___Mz 428: here');
          _b = false;
        }
        if (
          _hm.j(_gUserz.crt.i19rz.i19ra3200j) && _hm.j(_gUserz.crt.i19rz.i19ra3200j)["310"] == 1 &&
          !(_i18rz.i18ri16r1f >= 0) // ジャンル
        ) {
          //hf.l('icvI18___Mz 435: here');
          _b = false;
        }
        if (
          _hm.j(_gUserz.crt.i19rz.i19ra3200j) && _hm.j(_gUserz.crt.i19rz.i19ra3200j)["320"] == 1 &&
          !_hm.f(_i18rz.i18ra6100s) // 活動内容
        ) {
          //hf.l('icvI18___Mz 442: here');
          _b = false;
        }
        if (
          _hm.j(_gUserz.crt.i19rz.i19ra3200j) && _hm.j(_gUserz.crt.i19rz.i19ra3200j)["410"] == 1 &&
          !_hm.i(_i18rz.i18ra8300i, [1, -1]) // 会員募集
        ) {
          //hf.l('icvI18___Mz 449: here');
          _b = false;
        }
        if (!_b) {
          pz.sMsgz.show({
            textCz: {
              textz: {
                pfx: '必須項目を入力してください',
              }
            }
          })
        }
      }
      return _b;
    },
  ]);
  return _b;
};
